import(/* webpackMode: "eager" */ "/vercel/path0/apps/meet/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
